var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _ellipse, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScales(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 341,
    viewBox: "0 0 312 341",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.215 160.465H47.625H11L18.5128 170.237L29.7821 178.466H82.8413L93.1715 170.237L100.215 160.465Z",
    fill: "#D2D4F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6074 13.8864L43.399 0L55.6074 7.71468L66.8766 3.60019L249.532 58.6316L257.045 68.9178L271.131 66.8606L257.045 74.061L249.532 64.8033L66.8766 9.77193L55.6074 13.8864Z",
    fill: "#D2D4F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M153.274 230.412H160.317L163.22 239.155L191.777 241.727L211.498 255.099V261.271L195.534 267.442H119.936L102.562 261.271V255.099L119.936 241.727L150.371 239.155L153.274 230.412Z",
    fill: "#D2D4F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M304 221.154H265.966H214.785L222.298 230.926L233.567 239.155H286.627L296.957 230.926L304 221.154Z",
    fill: "#D2D4F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M153.274 230.412H160.317V37.9243L153.274 35.8022V230.412Z",
    fill: "#D2D4F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.876 9.77184L55.6068 13.8863V7.71459L66.876 3.6001V9.77184Z",
    fill: "#A491DD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M257.044 74.0609L249.531 64.8033V58.6315L257.044 68.9177V74.0609Z",
    fill: "#A491DD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M152.334 245.327L149.517 241.727L150.371 239.155L146.999 239.44L143.499 242.5L150.371 249.5H163.219L169.999 242.5L166.383 239.44L163.219 239.155L164.073 241.727L161.725 245.327H152.334Z",
    fill: "#A491DD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M153.273 230.412H160.317L161.768 234.783H151.822L153.273 230.412Z",
    fill: "#A491DD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M153.273 35.8021L160.317 37.9242V45.0005L153.273 42.7429V35.8021Z",
    fill: "#A491DD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11 160.465L55.6074 13.8865M100.215 160.465L55.6074 13.8865M55.6074 13.8865L47.625 160.465M257.045 74.061L304 221.154M257.045 74.061L214.785 221.154M257.045 74.061L265.966 221.154",
    stroke: "#D2D4F8",
    strokeWidth: 1.5,
    strokeLinejoin: "bevel"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7821 178.468H82.8413L11 160.467L18.5128 170.239L29.7821 178.468Z",
    fill: "#A491DD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M102.563 261.272V255.1L195.534 267.444H119.936L102.563 261.272Z",
    fill: "#A491DD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M233.567 239.157H286.627L214.785 221.156L222.298 230.928L233.567 239.157Z",
    fill: "#A491DD"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 156,
    cy: 316,
    rx: 156,
    ry: 25,
    fill: "url(#paint0_radial_839_14409)",
    fillOpacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_839_14409",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(156 316) rotate(90) scale(25 156)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A491DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScales);
export default __webpack_public_path__ + "static/media/Scales.eeec1de3ff84622e489cffdbdd0bb85e.svg";
export { ForwardRef as ReactComponent };